import { GROUP_TRAINING_TYPE } from 'constant/course';
import { useCourseStore } from 'store/createCourseStore';
import { DetailCourse } from 'types/lcms/courses';

export const useFormCourse = () => {
  const { setFormData } = useCourseStore();

  const setupFormCourse = (
    data: DetailCourse,
    dataPassingFormula?: { id: number; option: string; optionDesc: string }[]
  ) => {
    // Convert tags array to comma-separated string
    const tagsString = data.basicInformation.tags
      ? Array.isArray(data.basicInformation.tags)
        ? data.basicInformation.tags.join(',')
        : String(data.basicInformation.tags || '')
      : '';

    // Convert competencyCategory to string if it's an array
    const competencyCategoryString = data.basicInformation.competencyCategory
      ? Array.isArray(data.basicInformation.competencyCategory)
        ? data.basicInformation.competencyCategory.join(',')
        : String(data.basicInformation.competencyCategory)
      : '';

    // Convert specificJobBand to string if it's an array
    const specificJobBandString = data.basicInformation.specificJobBand
      ? Array.isArray(data.basicInformation.specificJobBand)
        ? data.basicInformation.specificJobBand.join(',')
        : String(data.basicInformation.specificJobBand || '')
      : '';

    // Ensure businessUnits is an array of strings or objects
    const businessUnitsArray = data.basicInformation.businessUnits
      ? Array.isArray(data.basicInformation.businessUnits)
        ? data.basicInformation.businessUnits.length === 0
          ? ['All']
          : data.basicInformation.businessUnits
        : []
      : [];

    const _activities =
      data.activities && data.activities.length > 0
        ? data.activities.map((activity) => ({
            activityName: activity.activityName,
            activityType: activity.activityType,
            activityId: activity.activityID
          }))
        : [];
    return setFormData({
      // Basic Information
      courseName: data.basicInformation.courseName,
      courseCode: data.basicInformation.courseCode,
      courseCategory: data.basicInformation.courseCategory,
      competencyCategory: competencyCategoryString,
      description: data.basicInformation.description,
      courseType: data.basicInformation.courseType,
      modeOfDelivery: data.basicInformation.modeOfDelivery,
      startDateTime: data.basicInformation.startDateTime,
      endDateTime: data.basicInformation.endDateTime,
      waReminder: data.basicInformation.waReminder,
      targetAudience: data.basicInformation.targetAudience,
      programCategory: data.basicInformation.programCategory,
      specificJobBand: specificJobBandString,
      learningContent: data.basicInformation.learningContent || '',
      levelOfTraining: data.basicInformation.levelOfTraining || '',
      learningFormat: data.basicInformation.learningFormat || '',
      trainingType: data.basicInformation.trainingType || '',
      fieldOrganizer: data.basicInformation.fieldOrganizer || '',
      room: data.basicInformation.room || '',
      trainingLocation: data.basicInformation.trainingLocation || '',
      weightPreTest: data.basicInformation.weightPreTest || '',
      weightPostTest: data.basicInformation.weightPostTest || '',
      weightALP: data.basicInformation.weightALP || '',
      weightAttendance: data.basicInformation.weightAttendance || '',
      targetBinusian: data.basicInformation.targetBinusian || '',
      jenisTraining: data.basicInformation?.jenisTraining || GROUP_TRAINING_TYPE[0].value,
      businessUnits: businessUnitsArray,
      tags: tagsString,
      bcldLevel: data.basicInformation.bcldLevel || '',
      bcldStreamOrFunda: data.basicInformation.bcldStreamOrFunda || '',
      status: data.basicInformation.status || '',

      // Delivery Details
      deliveryType: data.deliveryDetails.deliveryType,
      learningObjectives: data.deliveryDetails.learningObjectives,
      groupTrainingType: data.deliveryDetails.groupTrainingType,
      learningHours: data.deliveryDetails.learningHours.toString(),
      grpTraining: data.deliveryDetails.grpTraining,

      // Indicator Standards
      limIndicator: data.indicatorStandards.limIndicator,
      liaIndicator: data.indicatorStandards.liaIndicator,
      passingFormula: data.indicatorStandards.passingFormula,
      formulaID: data?.indicatorStandards?.formulaID
        ? data.indicatorStandards.formulaID
        : dataPassingFormula?.[0]?.id?.toString() || '',
      c: data.indicatorStandards.c ? data.indicatorStandards.c.split(',') : [],

      // Activities
      activities: _activities,

      // Review & Approval
      flagReviewSME: data.reviewApproval.flagReviewSME,
      picApproval1: data.reviewApproval?.picApproval[0]?.binusianID,
      picApproval2: data.reviewApproval?.picApproval[1]?.binusianID,
      smeExternal:
        data.reviewApproval?.smeExternal.length > 0
          ? data.reviewApproval?.smeExternal.map((sme) => `${sme.name}-${sme.email}`)
          : [],
      smeInternal:
        data.reviewApproval?.smeInternal.length > 0
          ? data.reviewApproval?.smeInternal.map((sme) => `${sme.name}-${sme.binusianID}`)
          : [],

      creatorCode: data.creatorCode || data.bcldModuleCode,
      bcldModuleCode: data.bcldModuleCode

      // Map other fields as needed
      // For arrays and complex objects, you may need additional mapping logic
    });
  };

  return {
    setupFormCourse
  };
};
